import { Component, input, model, OnChanges, output, SimpleChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { TextInputComponent } from '../text-input/text-input.component'

const toModel = (value: string): string => {
  // yyyy-MM-dd -> MM/yyyy
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return `${value.slice(5, 7)}/${value.slice(0, 4)}`
  } else {
    return ''
  }
}

const toValue = (model: string): string | undefined => {
  if (/^\d{2}\/\d{4}$/.test(model)) {
    // MM/yyyy -> yyyy-MM-dd
    const isoDate = `${model.slice(3)}-${model.slice(0, 2)}-01`
    if (!isNaN(new Date(isoDate).valueOf())) {
      return isoDate
    }
  }
  return undefined
}

@Component({
  selector: 'div[monthStringPicker]',
  imports: [FormsModule, TextInputComponent],
  template: `
    <div
        app-text-input
        placeholder="MM/yyyy"
        [slim]="true"
        [(value)]="model"
        (keyup)="handleKeyup($event)"
        (blur)="initModel()"
    >
    </div>
  `,
  styles: `
    :host {
      border: 1px solid black;
      border-radius: 5px;
      padding: 5px;
    }
  `,
})
export class MonthStringPickerComponent implements OnChanges {
  readonly value = input.required<string>()
  readonly valueChange = output<string>()
  readonly enter = output()

  protected readonly model = model('')

  constructor() {
    this.model.subscribe(modelValue => {
      const value = toValue(modelValue)
      if (value && value !== this.value()) {
        this.valueChange.emit(value)
      }
    })
  }

  protected handleKeyup(evt: KeyboardEvent){
    if (evt.key === 'Enter') {
      this.enter.emit()
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.initModel()
    }
  }

  protected initModel() {
    this.model.set(toModel(this.value()))
  }
}
